import React from 'react';
import './style/App.css';
import Routes from './routes'

//Importado a biblioteca ant design
import 'antd/dist/antd.css';

//Importado a biblioteca tachyons
import 'tachyons';


function App() {
  
  return <Routes />
}

export default App;
